import { h, p as proxyCustomElement, H, a as Host } from './index.js';
import { k as konsole } from './p-YbMWREgz.js';
import { t as toValue, a as toLabel } from './p-CPuegN2k.js';
import { H as HiddenHTMLSelect } from './p-BYoISW3Y.js';
import { d as defineCustomElement$g } from './p-C_esi8gV.js';
import { d as defineCustomElement$f } from './p-Cd2X-6KG.js';
import { d as defineCustomElement$e } from './p-CDhEAnE1.js';
import { d as defineCustomElement$d } from './p-VRJNF0zT.js';
import { d as defineCustomElement$c } from './p-DMseB40X.js';
import { d as defineCustomElement$b } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$a } from './p-CvrZ72pZ.js';
import { d as defineCustomElement$9 } from './p-Ddagsfv6.js';
import { d as defineCustomElement$8 } from './p-D4xpFZtu.js';
import { d as defineCustomElement$7 } from './p-Brrpvenv.js';
import { d as defineCustomElement$6 } from './p-BqzjvfBR.js';
import { d as defineCustomElement$5 } from './p-DE-WBrSS.js';
import { d as defineCustomElement$4 } from './p-aqq22Qbe.js';
import { d as defineCustomElement$3 } from './p-BqnaoLp8.js';
import { d as defineCustomElement$2 } from './p-B4Sv5V7D.js';

// biome-ignore lint/correctness/noUnusedImports: needed for Stencil
function SortOrderIcon(props) {
    return (h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "stroke-width": "2", stroke: "currentColor", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", ...props }, h("title", null, "Sort order"), h("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), h("g", { id: "dsc" }, h("path", { d: "M10 18l-3 3l-3 -3" }), h("path", { d: "M7 21l0 -18" })), h("g", { id: "asc" }, h("path", { d: "M17 3l0 18" }), h("path", { d: "M20 6l-3 -3l-3 3" }))));
}

const sortInputCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.sort-order{cursor:pointer;height:1rem;transition:stroke .2s ease;width:1rem}.sort-order,.sort-order:hover{stroke:var(--jw-theme-surface-text-helper-color)}:host([sort-order=asc]) .sort-order #asc,:host([sort-order=dsc]) .sort-order #dsc{stroke:var(--jw-theme-surface-text-default-color)}wui-input-menu [slot=prefix-icon],wui-list-item [slot=icon]{display:inline-flex}";

const WuiSortInput$1 = /*@__PURE__*/ proxyCustomElement(class WuiSortInput extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        /**
         * `sortField` options
         */
        this.options = [];
        /**
         * If disabled
         */
        this.disabled = false;
        /**
         * Input placeholder
         *
         * @type {string}
         */
        this.placeholder = '';
        this.open = false;
        this.setValue = (sortField, sortOrder) => {
            const newValue = `${sortField || this.getSortField()}:${sortOrder || this.getSortOrder()}`;
            this.value = newValue;
            this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
            this.elm.querySelector('button')?.focus();
        };
        this.getSortIcon = () => {
            if (this.getSortOrder() === 'asc') {
                return 'arrow-up';
            }
            return 'arrow-down';
        };
    }
    _watchValue(newValue) {
        if (!newValue) {
            return;
        }
        // Ensure sortOrder is present in value
        if (!(newValue.endsWith(':asc') || newValue.endsWith(':dsc'))) {
            konsole.warn.prop(this, 'value', this.value, `must contain a sortOrder 'asc' or 'dsc'`);
        }
    }
    getReverseSortOrder() {
        return this.getSortOrder() === 'asc' ? 'dsc' : 'asc';
    }
    getSortField() {
        return this.value?.split(':')[0];
    }
    getSortOrder() {
        return this.value?.split(':')[1];
    }
    getSelectedOption() {
        return this.options?.find((o) => toValue(o) === this.getSortField());
    }
    render() {
        const selectedOption = this.getSelectedOption();
        const selectedOptionValue = toValue(selectedOption);
        return (h(Host, { key: '36f088240e54c6d02544eb6b0eb08eb9038fc4a8', tabIndex: this.disabled ? -1 : 0, "is-empty": this.value?.length === 0, "sort-order": this.getSortOrder(), open: this.open }, h(HiddenHTMLSelect, { key: 'a7e17595b777a0e8daf1d88c53c189e41fa79a99', name: this.name, options: this.options, disabled: this.disabled, value: this.value, multiple: false }), h("wui-input-menu", { key: '4c0f564630bb54ea7a2a20c8027ab64602f9cfee', disabled: this.disabled, open: this.open, inputButton: {
                type: 'rich',
                label: toLabel(selectedOption),
            }, menuPane: this.menuPane, onOpenChanged: (e) => {
                this.open = e.detail;
            } }, h("div", { key: '0944612e634c3af5f03aa33ae03787e23b67a22d', slot: "prefix-icon" }, h(SortOrderIcon, { key: '642436cab870f6642bcfb89be52b55a2929adb6a', role: "button", class: "sort-order", onClick: (e) => {
                // Do not close menu
                e.stopPropagation();
                if (this.disabled) {
                    return;
                }
                this.setValue(this.getSortField(), this.getReverseSortOrder());
            } })), h("wui-list", { key: 'c2eea7b50fca27d9ea232b3c934d07a509b1bd57', scrollSize: "md" }, this.options?.map((option) => {
            const optionValue = toValue(option);
            const active = optionValue === selectedOptionValue;
            return (h("wui-list-item", { key: optionValue, active: active, onClick: (e) => {
                    // Do not close menu
                    e.stopPropagation();
                    const order = active ? this.getReverseSortOrder() : this.getSortOrder();
                    this.setValue(optionValue, order);
                }, label: toLabel(option), icon: active ? this.getSortIcon() : 'NULL' }));
        })))));
    }
    get elm() { return this; }
    static get watchers() { return {
        "value": ["_watchValue"]
    }; }
    static get style() { return sortInputCss; }
}, [257, "wui-sort-input", {
        "value": [1025],
        "options": [16],
        "name": [1],
        "disabled": [516],
        "menuPane": [16, "menu-pane"],
        "placeholder": [1],
        "open": [32]
    }, undefined, {
        "value": ["_watchValue"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-sort-input", "wui-badge", "wui-box", "wui-check-input", "wui-close-button", "wui-form-field", "wui-icon", "wui-input-button", "wui-input-menu", "wui-list", "wui-list-item", "wui-loader", "wui-menu-pane", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-sort-input":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiSortInput$1);
            }
            break;
        case "wui-badge":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-input-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-input-menu":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiSortInput = WuiSortInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiSortInput, defineCustomElement };
